import { cHeader } from "../header/header";

export class cSidebar {

  sidebar          = document.querySelector('.c-sidebar')               as HTMLElement;
  sidebarButton    = document.querySelector('.c-sidebar-button')        as HTMLButtonElement;

  constructor(top: cHeader) {

    // ---- event ----
    this.sidebarButton.addEventListener('click', (e) => {
      e.stopPropagation();
      if (this.sidebar.classList.contains('c-sidebar-open')) {
        top.closeAll();
        this.closeTransition();
      }
      else {
        top.closeAll();
        this.openTransitinon()

      }
    });

    this.sidebar.addEventListener('click', (e) => {
      e.stopPropagation();
    });
  }

  close() {
    this.closeTransition();
  }

  openTransitinon() {
    this.sidebar.classList.add('c-sidebar-open');
    this.sidebar.classList.add('c-open');
    this.sidebar.classList.remove('c-close');
  }
  closeTransition() {
    this.sidebar.classList.remove('c-sidebar-open');
    this.sidebar.classList.remove('c-open');
    this.sidebar.classList.add('c-close');
  }
  openDirect() {
    this.sidebar.classList.add('c-sidebar-open');
    this.sidebar.classList.remove('c-open');
    this.sidebar.classList.remove('c-close');
  }
  closeDirect() {
    this.sidebar.classList.remove('c-sidebar-open');
    this.sidebar.classList.remove('c-open');
    this.sidebar.classList.remove('c-close');
  }
}